import { Header } from '@business/workflows/ComponentUI';
import { AdminSidebar } from '@business/workflows/ComponentUI/Admin/AdminSidebar';
import { FC, ReactNode } from 'react';

interface AdminLayoutProps {
  children?: ReactNode;
  wrapperClassName?: string;
}

export const AdminLayout: FC<AdminLayoutProps> = ({
  children,
  wrapperClassName
}) => {
  return (
    <div>
      <div className="h-screen flex overflow-hidden bg-white relative">
        <AdminSidebar />
        <div className="flex-1 flex flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto">
            <div className={`px-2 sm:px-3 lg:px-4 py-4 ${wrapperClassName}`}>
              {children}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
